import React from "react";
import { UMSSBlue, UMSSBlueLight, UMSSGold, UMSSGoldLight } from "../utils/colors";

function Navigation({ currentStep, onBack, onNext, maxStep, nextDisabled, confirmationConfirmed }) {
  const navStyle = {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTop: "1px solid #ccc",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    boxSizing: "border-box"
  };

  const buttonStyle = {
    padding: "10px 20px",
    backgroundColor: UMSSGold,
    color: "#fff",
    border: "none",
    borderRadius: "15px",
    cursor: nextDisabled ? "default" : "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    fontFamily: "Quicksand, sans-serif",
    transition: "background-color 0.3s ease",
  };

  const backButtonStyle = {
    ...buttonStyle,
    backgroundColor: UMSSBlue,
  };

  const buttonHoverStyle = {
    backgroundColor: UMSSGoldLight,
  };

  const backButtonHoverStyle = {
    backgroundColor: UMSSBlueLight,
  };

  return (
    <div style={navStyle}>
      {(currentStep > 1 && !(currentStep === 5 && confirmationConfirmed)) ? (
        <button
          onClick={onBack}
          style={backButtonStyle}
          onMouseEnter={(e) => e.target.style.backgroundColor = backButtonHoverStyle.backgroundColor}
          onMouseLeave={(e) => e.target.style.backgroundColor = backButtonStyle.backgroundColor}
        >
          Back
        </button>
      ) : <div />}
      {currentStep < maxStep && (
        <button
          onClick={!nextDisabled ? onNext : undefined}
          disabled={nextDisabled}
          style={{
            ...buttonStyle,
            backgroundColor: nextDisabled ? "#ccc" : buttonStyle.backgroundColor,
            cursor: nextDisabled ? "default" : "pointer"
          }}
          onMouseEnter={(e) => {
            if (!nextDisabled)
              e.target.style.backgroundColor = buttonHoverStyle.backgroundColor;
          }}
          onMouseLeave={(e) => {
            if (!nextDisabled)
              e.target.style.backgroundColor = buttonStyle.backgroundColor;
          }}
        >
          Next
        </button>
      )}
    </div>
  );
}

export default Navigation;